import React from 'react';
import Typography from './Typography';

const CustomRange = ({
    milestones = [
        { label: 'Start', subLabel: '$0', position: 0 },
        { label: '1 mo', subLabel: '$4k', position: 16.67 },
        { label: '2 mo', subLabel: '$8k', position: 33.34 },
        { label: '3 mo', subLabel: '$13k', position: 50 },
        { label: '5 mo', subLabel: '$18k', position: 83.34 },
        { label: '6 mo', subLabel: '$30k', position: 100 },
    ],
    className,
    progress = 50, // Percentage of progress (where the color changes)
    activeColor = '#DF0F11', // Red color for active portion
    inactiveColor = '#4A4A4A', // Gray color for inactive portion
}) => {
    return (
        <div className={`${className} relative w-full mx-auto block h-[60px] mt-[33px] sm:pr-10 pr-2`}>
            {/* Background Line */}
            <div className="relative w-full h-[2px] pr-10">
                <div
                    className="absolute top-0 left-0 w-full h-full"
                    style={{
                        background: `linear-gradient(to right, ${activeColor} ${progress}%, ${inactiveColor} ${progress}%)`,
                    }}
                />
            </div>

            {/* Milestones */}
            <div className="relative w-full">
                {milestones.map((milestone, index) => {
                    const isActive = milestone.position <= progress;
                    return (
                        <div
                            key={index}
                            className="absolute flex flex-col items-center transform -translate-x-1/2 top-[-10px]"
                            style={{ left: `${milestone.position}%` }}
                        >
                            {index === 0 ? <div className="w-4 h-4 rounded-full bg-white border-2 border-[#1B1B1B]" /> : <svg xmlns="http://www.w3.org/2000/svg" width="4" height="18" viewBox="0 0 4 18" fill="none">
                                <path d="M2 0.133333C0.969069 0.133333 0.133333 0.969068 0.133333 2C0.133333 3.03093 0.969068 3.86667 2 3.86667C3.03093 3.86667 3.86667 3.03093 3.86667 2C3.86667 0.969069 3.03093 0.133333 2 0.133333ZM1.65 2L1.65 18L2.35 18L2.35 2L1.65 2Z" fill="white" />
                            </svg>}
                            <div className={`${index === 0? 'mt-3' : 'mt-2'} text-center`}>
                                <Typography className={`${index === 0 && 'ml-4'} min-w-[60px]`} text={milestone.label} size={'12px'} weight={400} lineheight={'170%'} color={'#FFF'} opacity={0.6} />
                                <Typography className='mt-2' text={milestone.subLabel} size={'10px'} weight={400} lineheight={'170%'} family={'Supply'} color={isActive? '#DF0F11' : '#FFF'} />
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    );
};

export default CustomRange;